declare global {
  interface Window {
    hsConversationsSettings?: {loadImmediately?: boolean};
  }
}

// HubSpot's all-in-one tracking loader (portal 20745831). CTA banners ride on
// this script. We only want the banners here — hf-web already uses HelpScout
// for chat — so we set `loadImmediately: false` to keep HubSpot's own chat
// widget from auto-appearing.
const HUBSPOT_SRC = 'https://js-na1.hs-scripts.com/20745831.js';
const HUBSPOT_SCRIPT_ID = 'hs-script-loader';

function buildScript(): HTMLScriptElement {
  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.defer = true;
  script.src = HUBSPOT_SRC;
  return script;
}

export function initHubspot() {
  if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
    return;
  }

  window.hsConversationsSettings = {loadImmediately: false};
  document.head.appendChild(buildScript());
}
